<template>
  <VApp id="app">
    <RouterView />
  </VApp>
</template>

<script>
import * as R from 'ramda'

export default {
  data: () => ({
    integration: null,
  }),
  computed: {
    authorized() { return !!this.$store.state.auth.token },
  },
  watch: {
    $route: {
      handler(to, from) {
        document.title = to.meta.title
          ? `${to.meta.title} – ${this.$const.APP_NAME}`
          : this.$const.APP_NAME
        if (from && from.name && this.$vuetify.breakpoint.smAndDown) {
          this.$store.commit('ui/setDrawer', { value: false })
        }
        window.scroll(0, 0)
      },
      immediate: true,
    },
    '$route.query': {
      handler(query) {
        const omit = []
        if (query && query.x) {
          omit.push('x')
        }
        if (process.env.NODE_ENV === 'development' && query && query._dev_script) {
          omit.push('_dev_script')
          const scriptHtml = decodeURIComponent(query._dev_script)
          this.$nextTick()
            .then(() => {
              const el = document.createElement('div')
              el.innerHTML = scriptHtml;
              (new Function(el.children[0].innerHTML))() // eslint-disable-line no-new-func
            })
            .then(() => this.$store.devSyncAuth())
        }
        if (omit.length) {
          this.$router
            .replace({ query: R.omit(omit, query) })
            .catch(console.warn)
        }
      },
      immediate: true,
    },
    authorized: {
      handler(authorized) {
        if (authorized) {
          this.$store.dispatch('company/getCurrent')
          this.$store.dispatch('user/getCurrent')
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
</style>

<style>
@import "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900";
@import "https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css";
</style>
